/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarColumns: {
  name: 'bar-columns';
  data: string;
} = {
  name: 'bar-columns',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h3v14H5V5Zm11 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3Zm0 2h3v10h-3V9Z" fill="currentColor"/></svg>`,
};
